

<div style="background-color: #1c2439; padding: 10px; margin-bottom: 1rem;">
  <div class="flex flex-column align-items-center justify-content-center mb-4">
    <img class="logo" src="/assets/images/logo-guai.png" width="120">
    <!--<b class="company-name">GUAI Insurtech</b>-->
  </div>
</div>

<div class="m-4">

  <div class="mb-4">
    <p-card styleClass="info">
      <ng-template pTemplate="header">
          <div class="flex justify-content-center align-items-center pb-0 gap-2">
              <div class="p-card-title">Datos generales</div>
          </div>
      </ng-template>
      <div class="flex flex-column">
          <div class="grid">
              <div class="col-12 md:col-2"><strong>Nº de expediente:</strong></div>
              <div class="col-12 md:col-10"><strong>{{case.caseNumber}}</strong></div>
          
              <div class="col-12 md:col-2">Empresa reparadora:</div>
              <div class="col-12 md:col-10">{{case.contract?.business?.legalName}}</div>
          
              <div class="col-12 md:col-2">Teléfono:</div>
              <div class="col-12 md:col-10"><a href="tel:{{case.contract?.business?.phone1}}">{{case.contract?.business?.phone1}}</a></div>
          </div>
      </div>
    </p-card>
  </div>

  <div class="mb-4">
    <p-card styleClass="info">
      <div class="flex align-items-center pb-0 gap-2">
        <div class="p-card-title">Visitas</div>
      </div>
      
      <br>
      <p-panel header="Hoy">
        <div *ngIf="caseService">
          <div class="flex w-full">
            <div>Recibirá la visita de nuestro operario hoy a las {{caseService?.date | date: 'HH:mm'}}</div>
            <div class="flex-grow-1"></div>
            <p-button (click)="isMapVisible=!isMapVisible" size="small">Ver operario</p-button>
          </div>
          <div *ngIf="isMapVisible" class="mt-3">
            <div *ngIf="!this.caseService.worker?.latitude">
              <p-messages severity="warn">
                <ng-template pTemplate>
                  No hay datos de ubicación del operario.
                </ng-template>
              </p-messages>
            </div>
            <div *ngIf="this.caseService.worker?.latitude && !isMapAllowed()">
              <p-messages severity="warn">
                <ng-template pTemplate>
                  Solo puede visualizar la ubicación del operario a partir de la hora prevista de visita.
                </ng-template>
              </p-messages>
            </div>
            <div style="width: 100%; height: 500px;" *ngIf="this.caseService.worker?.latitude && isMapAllowed()">
              <google-map width="100%" height="100%" 
                  [center]="center"
                  [zoom]="zoom">
                  <map-marker *ngFor="let marker of markerPositions" [position]="marker"></map-marker>   
              </google-map>
            </div>
          </div>
          
        </div>
        <div *ngIf="!caseService">No hay visitas para hoy.</div>
      </p-panel>
        
        <div class="pt-3" *ngIf="caseServices.length > 0">
          <p-table  *ngIf="caseServicesFuture.length > 0" #grid [value]="caseServicesFuture" [loading]="loadingNotes" [paginator]="false" [rows]="5"
              [showCurrentPageReport]="false" [scrollable]="true" scrollHeight="flex">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th>Próximas visitas</th>
                    <th width="120"></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service let-columns="columns">
                  <tr>
                      <td>Visita del {{service.date | date: 'dd/MM/yyyy'}} a las {{service.date | date: 'HH:mm'}}</td>
                      <td><p-button *ngIf="service.dateEnd!=null"  size="small" (onClick)="export(service)">Ver parte</p-button></td>
                  </tr>
              </ng-template>
          </p-table>
          <br>
          <p-table *ngIf="caseServicesPrev.length > 0" #grid [value]="caseServicesPrev" [loading]="loadingNotes" [paginator]="false" [rows]="5"
              [showCurrentPageReport]="false" [scrollable]="true" scrollHeight="flex">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th>Visitas anteriores</th>
                    <th width="120"></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-service let-columns="columns">
                  <tr>
                      <td>Visita del {{service.date | date: 'dd/MM/yyyy'}} a las {{service.date | date: 'HH:mm'}}</td>
                      <td><p-button *ngIf="service.dateEnd!=null" size="small" (onClick)="export(service)">Ver parte</p-button></td>
                  </tr>
              </ng-template>
          </p-table>

        </div>
    </p-card>
  </div>

  <div class="mb-4">
    <p-panel [toggleable]="true" [collapsed]="true" (collapsedChange)="photosCollapsed=$event" styleClass="info">
      <ng-template pTemplate="header">
          <div class="p-panel-title w-full flex align-items-center pb-0 gap-2">
              <div>Fotos</div>
              <div class="flex-grow-1"></div>
              <div class="p-badge p-badge-secondary">{{caseFilesWithoutService.length}}</div>
          </div>
      </ng-template>

      <div class="pt-2" *ngIf="!photosCollapsed">
          <div class="grid">
              <div *ngFor="let file of caseFilesWithoutService" class="col-12  md:col-4 lg:col-2 xl:col-2 ">
                  <div *ngIf="fileIsAnImage(file.file)"
                      style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;" (click)="downloadFile(file.fileId)">
                      <img [src]="imagesUrl + file.fileId + '/image-resize?width=240&height=240'" alt="{{file.file.fileName}}"
                          class="w-full" />
                      <div class="flex justify-content-between align-items-center mt-1">
                          <span>{{file.file.fileName}}</span>
                      </div>
                  </div>
                  <div *ngIf="!fileIsAnImage(file.file)"
                      style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;" (click)="downloadFile(file.fileId)">
                      <i class="pi pi-file" style="font-size: 80px;"></i>
                      <div class="flex justify-content-between align-items-center mt-1">
                          <span>{{file.file.fileName}}</span>
                      </div>
                  </div>
              </div>
              <!--<div class="col-3 flex flex-column align-items-center" style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                <div class="mt-1">
                  <p-button>AÑADIR FOTO</p-button>
                </div>
              </div>-->
          
          </div>
          
      </div>
    </p-panel>
  </div>



  <div class="mb-4">
    <p-card styleClass="info">
      <div class="flex align-items-center pb-0 gap-2">
        <div class="p-card-title">Consultas</div>
        <div class="flex-grow-1"></div>  
        <p-button label="Añadir" icon="pi pi-plus" (click)="editNote(null, true)"  size="small" />
      </div>
    <div class="pt-2">
      <p-table #grid [value]="ClientQuestion" [loading]="loadingNotes" [paginator]="true" [rows]="5"
          [totalRecords]="totalClientQuestionRecords" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
          [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
          paginatorDropdownAppendTo="body">
          <ng-template pTemplate="header" let-columns>
              <tr>
                <th width="150">Fecha</th>
                <th>Notas</th>
                <th width="100"></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-note let-columns="columns">
              <tr (dblclick)="editNote(note, true)">
                  <td>{{note.date | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>{{note.notes}}</td>

                  <td>
                      <div class="flex gap-2 justify-content-end">
                          <!--<p-button *ngIf="allowDelete" (click)="deleteNote(note.id)" [rounded]="true"
                              [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>-->
                          <p-button (click)="editNote(note, true)" [rounded]="true"
                              [text]="false"><i class="pi pi-pencil"></i></p-button>
                      </div>
                  </td>
              </tr>
          </ng-template>
      </p-table>
    </div>
    </p-card>
  </div>


  <div class="mb-4">
    <p-card styleClass="info">
      <ng-template pTemplate="header">
          <div class="flex align-items-center pb-0 gap-2">
              <div class="p-card-title">Reclamaciones</div>
              <div class="flex-grow-1"></div>  
              <p-button label="Añadir" icon="pi pi-plus" (click)="editNote(null, false)"  size="small" />
          </div>
      </ng-template>
      <div class="flex flex-column">
        <p-table #grid [value]="ClientReclamation" [loading]="loadingNotes" [paginator]="true" [rows]="5"
            [totalRecords]="totalClientReclamationRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
            paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th width="150">Fecha</th>
                    <th>Notas</th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-note let-columns="columns">
                <tr (dblclick)="editNote(note, false)">
                    <td>{{note.date | date: 'dd/MM/yyyy HH:mm'}}</td>
                    <td>{{note.notes}}</td>
                    <td>
                        <div class="flex gap-2 justify-content-end">
                            <!--<p-button *ngIf="allowDelete" (click)="deleteNote(note.id)" [rounded]="true"
                                [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>-->
                            <p-button (click)="editNote(note, false)" [rounded]="true"
                                [text]="false"><i class="pi pi-pencil"></i></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>

  <div class="mb-4">
    <p-card styleClass="info">
      <ng-template pTemplate="header">
          <div class="flex align-items-center pb-0 gap-2">
              <div class="p-card-title">Facturas</div>
          </div>
      </ng-template>
      <div class="flex flex-column">
        <p-table [value]="invoices" [loading]="loadingNotes">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th width="150">Nº factura</th>
                    <th>Fecha</th>
                    <th>Base</th>
                    <th>IVA</th>
                    <th>Total</th>
                    <th>Forma de pago</th>
                    <th>Fecha de pago</th>
                    <th>Estado</th>
                    <th width="100"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice let-columns="columns">
                <tr>
                    <td>{{invoice.code}}</td>
                    <td>{{invoice.date | date: 'dd/MM/yyyy'}}</td>
                    <td>{{invoice.subtotal | number:'1.2-2'}} &euro;</td>
                    <td>{{invoice.taxAmount | number:'1.2-2'}} &euro;</td>
                    <td>{{invoice.total | number:'1.2-2'}} &euro;</td>
                    <td>
                      <div>{{invoice.paymentMethod?.name}}</div>
                      <div *ngIf="invoice.paymentMethod?.businessBankAccountEnabled">{{invoice.businessBankAccount?.accountNumber}}</div>
                    </td>
                    <td>{{invoice.paymentDuedate | date: 'dd/MM/yyyy'}}</td>
                    <td>
                      <div class="p-badge" [style.backgroundColor]="invoice.transactionState?.backgroundColor" [style.color]="invoice.transactionState?.foregroundColor">{{invoice.transactionState?.name}}</div>
                    </td>
                    <td>
                      <div class="flex gap-2 justify-content-end">
                        <p-button *ngIf="invoice.transactionState?.code == 'pending' && invoice.paymentMethod?.code == 'TPV'" (click)="pay(invoice)" [rounded]="true" [text]="false"><i class="pi pi-credit-card"></i>&nbsp;Pagar</p-button>
                        <p-button (click)="exportInvoice(invoice)" [rounded]="true" [text]="false"><i class="pi pi-file-pdf"></i>&nbsp;PDF</p-button>
                      </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>

</div>

<div class="mt-4 p-4 flex gap-2 justify-content-center">
  <a href="/public/legal/{{case.contract?.billingCompanyId}}/info">Aviso legal, políticas de privacidad y protección de datos</a>
  <a href="/public/legal/{{case.contract?.billingCompanyId}}/terms">Condiciones de venta</a>
</div>

<div class="mb-4 flex gap-2 justify-content-center">
  <img src="/assets/images/redsys-payment-methods.png" alt="Formas de pago" height="100">
</div>